import React, { useEffect, useState } from "react";
import { OBJECT_EMPTY } from '../../../helpers';
import { setDefaultLocale } from "react-datepicker";
import Select from 'react-select' // https://react-select.com/props

import "./SelectInput.css";


export const SelectInput = (
  {
    inputName,
    labelText,
    defaultValue,
    placeholder,
    selectHeight,
    disabled,
    error,
    selectValues,
    className,
    value,
    helperText,
    noOptionsMessage,

    inputValueHandler,
  }) => {

  const inputConstructor = () => {
    return <Select 
      name={inputName}
      options={selectValues}
      isDisabled={disabled && disabled}
      placeholder={placeholder && placeholder}
      className={'select ' + (error ? "error " : "")}
      classNamePrefix='select'
      onChange={(e) => {
        e && inputValueHandler(e)
      }}
      value={value ?? {label: '', value: ''}}
      noOptionsMessage={() => noOptionsMessage ? noOptionsMessage : 'No options'}

      styles={{
        control: () => ({
          height: selectHeight ? selectHeight : 35
        })
      }}
    />
  }

  return (
    <div
      className={
        "SelectInput" + (disabled ? " disabled" : "") + (error ? " inputError" : "") + (className ? (' ' + className) : "")
      }
    >
      {labelText && (
        <div className="label-wrapper">
          <label htmlFor={labelText}>{labelText}</label>
        </div>
      )}

      <div className='input-wrapper'>
        {inputConstructor()}
      </div>

      {error 
        ? <p className="Input_error error">{error}</p> 
        : (helperText && <p className="Input_helper">{helperText}</p>)
      }
    </div>
  );
};
